export enum ContractStatus {
    New,
    Active,
    Locked,
    Cancelled,
    Terminated,
    Completed
}